import store from "@/store/auth";
import Auth from "@/store/auth";

let Competitors = function () {
    this.get = function () {
        return new Promise((resolve) => {
            let url = process.env.VUE_APP_API + "competitors/";

            fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json)
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                    resolve([])
                }
            });
        });
    }

    this.getLastPriceChange = function () {
        return new Promise((resolve) => {
            let url = process.env.VUE_APP_API + "competitors/last_price_change/";

            fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + store.getters.getJwt
                }
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(json => {
                        resolve(json)
                    });
                } else if (response.status === 401) {
                    Auth.dispatch("setJwt", "");
                    resolve([])
                }
            });
        });
    }
}

export default new Competitors();
